import { startLoginWithGoogle } from "actions/authFunctions"
import LoginButton from "components/utils/loginButtons/LoginButton"
import googleIcon from "images/login/google.svg"

const GoogleLoginButton = () => {
  return <LoginButton icon={googleIcon} text="Mit Google anmelden" onClick={startLoginWithGoogle} />
}

export default GoogleLoginButton
